import {
  DropDownSelect,
  Form,
  yupMultiSelectFormat,
  useWindowWidth,
  HeroBackground,
  Button,
} from '@prishapolicy/shared/ui';
import {
  insuranceBenefitsLogo,
  offSitesAndRitualsLogo,
  professionalDevelopmentLogo,
  collageDesktop,
  uniqueLeaveStructureLogo,
  collagePhone,
} from '@prishapolicy/w3/assets';
import { JobProps, jobs, TeamJobsProps, Teams } from '@prishapolicy/w3/ui';
import Image from 'next/image';
import TimeLineIcon from 'remixicon-react/TimeLineIcon';
import MapPinLineIcon from 'remixicon-react/MapPinLineIcon';
import WifiLineIcon from 'remixicon-react/WifiLineIcon';
import { object } from 'yup';
import { useFormikContext } from 'formik';
import { RemixiconReactIconComponentType } from 'remixicon-react';
import { NextSeo } from 'next-seo';

const locationFilter: {
  name: string;
  accent: string;
  options: {
    value: JobProps['location'];
    icon: RemixiconReactIconComponentType;
  }[];
}[] = [
  {
    name: 'Location',
    accent: 'blue',
    options: [
      {
        value: 'Gurugram',
        icon: MapPinLineIcon,
      },
      {
        value: 'All Locations',
        icon: MapPinLineIcon,
      },
      {
        value: 'Remote',
        icon: WifiLineIcon,
      },
    ],
  },
];
const Job = (props: JobProps) => {
  return (
    <div
      className="hover:border-grey-300 border-grey-200 rounded-huge mb-5 cursor-pointer border py-6 lg:p-6"
      onClick={() => window.open(props.link)}
    >
      <div className="flex">
        <div className="text-title-7 flex-1 px-6 font-medium">{props.jobName}</div>
        <div className="text-grey-700 hidden items-center lg:grid lg:grid-cols-2">
          <div className="col-span-1 grid">
            <div className="mr-2 flex">
              <TimeLineIcon className="mr-2" />
              {props.time}
            </div>
          </div>
          <div className="bg-grey-100 rounded-huge text-body-3 col-span-1 grid py-1 px-4 text-center">
            {props.location}
          </div>
        </div>
      </div>
      {/* <div className="mt-2 text-grey-700 lg:border-none pb-3 border-grey-300">
        <div className="px-6">{props.description}</div>
      </div> */}
      <div className="text-grey-700 mt-3 flex items-center justify-between px-6 lg:hidden">
        <div className="mr-2 flex">
          <TimeLineIcon className="mr-2" />
          {props.time}
        </div>
        <div className="bg-grey-100 rounded-huge text-body-3 py-1 px-4">{props.location}</div>
      </div>
    </div>
  );
};
const TeamJobs = (props: TeamJobsProps) => {
  const formikContext = useFormikContext();
  const jobsInTeam = props.jobs.map((job, index) => {
    const value = formikContext.values['location'];
    const showJob = value === undefined || job.location === value || value === 'All Locations';
    return showJob && <Job key={index} {...job} />;
  });
  return (
    jobsInTeam.some((job) => job) && (
      <div className="grid-cols-3 bg-white py-10 lg:grid">
        <div className="">
          <h6 className="heading-6">{props.teamName}</h6>
          <p className="text-grey-700 my-4 lg:mt-2">Open positions in our {props.teamName} team.</p>
        </div>
        <div className="col-span-2">{jobsInTeam}</div>
      </div>
    )
  );
};
const JobListings = () => {
  return (
    <Form
      initialValues={{
        location: 'All Locations',
      }}
      validationSchema={object().shape({
        location: yupMultiSelectFormat,
      })}
      className="container mt-20"
    >
      <div className="border-grey-200 grid-cols-3 border-b pb-10 lg:grid ">
        <div className="col-span-2 my-6 lg:my-0">
          <div className="lg:w-3/4">
            <h2 className="heading-4 lg:heading-2">Start doing work that matters</h2>
            <p className="text-grey-700">
              Want to work with some of the best talent in the industry and want build a new generation of insurance?
              Join the team - we are hiring!
            </p>
          </div>
        </div>
        <div className="flex items-center gap-x-4">
          <div className="hidden lg:inline">Location:</div>
          <DropDownSelect label={false} name="location" multiSelect={false} options={locationFilter} />
        </div>
      </div>
      <div className="bg-grey-200 grid gap-y-px">
        {jobs.map((teamJobs, idx) => {
          return <TeamJobs {...teamJobs} key={idx} />;
        })}
      </div>
    </Form>
  );
};
const perksAndBenefits = [
  [
    {
      title: 'Health Insurance',
      image: insuranceBenefitsLogo,
      description:
        'We provide Health Insurance, Personal Accident Insurance and Term Life Insurance for all employees.',
    },
    {
      title: 'Unique leave structure',
      image: uniqueLeaveStructureLogo,
      description:
        'Our unique leave structure empowers our employees to be more flexible and have a good work life balance',
    },
    {
      title: 'Personal Accidental',
      image: insuranceBenefitsLogo,
      description:
        'Our employees & their families must not suffer financially due to loss of income during an accidental event',
    },

    {
      title: 'Professional Development',
      image: professionalDevelopmentLogo,
      description:
        'We understand that insurance can be a difficult subject, to counter we aim to make our training programs to ensure that any and all employees can learn about insurance in no time.',
    },
    {
      title: 'Off sites & Rituals',
      image: offSitesAndRitualsLogo,
      description:
        'Work hard, Play hard! Thats what we live by and to ensure that enthusiasm across our employees we plan various rituals and offsites.',
    },
  ],
];
const PerksAndBenefits = () => {
  const { isLg } = useWindowWidth();
  return (
    <div className="bg-surface-grey">
      <div className="container py-12">
        <h3 className="heading-3 mb-6 text-center">Our Perks & Benefits</h3>
        {(isLg ? perksAndBenefits : [perksAndBenefits.flat()]).map((row, index) => {
          return (
            <div className={`my-6 lg:grid grid-cols-${row.length} flex flex-col gap-x-4 gap-y-5`} key={index}>
              {row.map((perk, idx) => {
                return (
                  <div
                    className="rounded-large border-grey-200 flex flex-col gap-4  border-2 bg-white px-6 pt-6 pb-8"
                    key={idx}
                  >
                    <div className="flex items-center gap-5 ">
                      <div
                        style={{
                          width: 56,
                          height: 56,
                        }}
                      >
                        <Image src={perk.image} alt={perk.title} layout="responsive" />
                      </div>
                      <div className="flex-1 items-center justify-center">
                        <h6 className="text-title-7 font-bold">{perk.title}</h6>
                      </div>
                    </div>
                    <div className="">
                      <p className="mt-2">{perk.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const CareersResumeUpload = () => {
  return (
    <div className="bg-surface-blue">
      <div className="py-15 flex flex-col items-center justify-center gap-11 px-[70px]">
        <div className="flex flex-col ">
          <h1 className="text-title-3 text-center font-bold xl:text-[40px]">
            Did not find the role you were looking for ?
          </h1>
          <p className="text-body-1 xl:text-title-5 text-center font-medium">
            We are always seeking for passionate people to join us!{' '}
          </p>
        </div>
        <div>
          <Button text="Send Resume" rightIcon="arrowRight" size="large" />
        </div>
      </div>
    </div>
  );
};

export const Careers = () => {
  const { isLg } = useWindowWidth();
  return (
    <>
      <NextSeo title="Careers | PrishaPolicy" description="Careers at PrishaPolicy : To changing insurance for good" />
      <HeroBackground backgroundColor="blue-200">
        <div className="container">
          <div className="text-center">
            <h5 className="lg:heading-5 text-title-5 font-medium">Careers</h5>
            <h1 style={{ fontSize: 40 }} className="mb-4 font-bold">
              To changing insurance for goood!
            </h1>
            <h6 className="text-title-6 ">
              Join the team that is making insurance accessible, transparent, and human.
            </h6>
          </div>
        </div>
      </HeroBackground>
      <Teams />
      <div className="container  my-16 lg:block">
        <Image src={isLg ? collageDesktop : collagePhone} alt="prishapolicy team" />
      </div>
      <PerksAndBenefits />
      <JobListings />
      <CareersResumeUpload />
    </>
  );
};
export default Careers;